module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbar-item-container"
  }, [_c('div', {
    staticClass: "item-content-container",
    class: {
      'item-content-container-selected': _vm.selected
    }
  }, [_c('div', [_c('icon', {
    staticClass: "tab-icon",
    attrs: {
      "className": "icon",
      "symbol": _vm.iconName
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tab-title"
  }, [_vm._v(_vm._s(_vm.tabTitle))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a3eb8778!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/common/xy-tabbar-item.vue
// module id = 411
// module chunks = 36